module.exports = __webpack_public_path__ + "img/Avatar-77.f08bd3ab.svg";